export default __webpack_public_path__ + "static/hot_tub_2-a96dd75640d63c6bfa6ed128f735d7bd.jpg";